import DivisionHistory from '../division/divisionHistory';

function DivisionHistoryPage() {
  return (
    <DivisionHistory />
  );
}

export default DivisionHistoryPage;
